import React, { Component } from "react";

class ImageDiv extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }
 
  openDef = () => {
    this.setState({
      ...this.state,
      open: true,
    });
  };
  closeDef = () => {
    this.setState({
      ...this.state,
      open: false,
    });
  };
  render() {
    return (
      <div
        className={`flex-column ${this.props.columns} ${this.props.divClass} lesson-image-container`}
      >
        {this.props.class === "blue" ? (
          <div className="blue-parent">
            <img
              src={this.props.image.image}
              alt={this.props.image.alt}
              className={`lesson-image ${this.props.class}`}
            />
            <p className="caption link" onClick={() => this.openDef()}>
              {this.props.image.alt} &rarr;
            </p>
            {this.state.open && <p className="caption sub-caption">{this.props.definition}</p>} 
          </div>
        ) : ( <div>{this.props.class === 'chooseOne' ? ( <div>
          <img
            src={this.props.image.image}
            alt={this.props.image.alt}
            className={`lesson-image ${this.props.class}`}
          />
        </div>):( <div>
          <img
            src={this.props.image.image}
            alt={this.props.image.alt}
            className={`lesson-image ${this.props.class}`}
          />
            <p className="caption">{this.props.image.alt}</p>
        </div>)}
         
          </div>
        )}
      </div>
    );
  }
}

export default ImageDiv;
